webpackJsonp([187],{

/***/ 1168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "为什么不能引入全部组件？ | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1983:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1168),
  /* template */
  __webpack_require__(2289),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/why-cannot-i-import-all-components-19.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] why-cannot-i-import-all-components-19.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62f50588", Component.options)
  } else {
    hotAPI.reload("data-v-62f50588", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2289:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("为什么不能引入全部组件")]), _vm._v(" "), _c('p', [_vm._v("移动端引入全部组件会导致体积过大，加载速度慢，浪费用户等待时间并且浪费(cdn)带宽。")]), _vm._v(" "), _c('p', [_vm._v("另一方面随着组件库迭代，组件数量增加，这个体积会逐渐变得不可接受。")]), _vm._v(" "), _c('p', [_vm._v("因此 "), _c('code', [_vm._v("VUX")]), _vm._v(" 没有像其他组件库一样直接提供全部引入的使用方式，按需使用是最佳实践。")]), _vm._v(" "), _c('p', [_vm._v("如果你只是不想每次在单个 "), _c('code', [_vm._v(".vue")]), _vm._v(" 文件里重复地 "), _c('code', [_vm._v("import")]), _vm._v("，那么你可以直接在 "), _c('code', [_vm._v("main.js")]), _vm._v(" 里进行全局注册。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Group, Cell } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nVue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'group'")]), _vm._v(", Group)\nVue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'cell'")]), _vm._v(", Cell)\n")])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_c('code', [_vm._v("VUX@3.0")]), _vm._v(" 将会实现无声明使用组件。")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62f50588", module.exports)
  }
}

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1983);

/***/ })

});


// WEBPACK FOOTER //
// 187.2647938d.js